export default {
  appConfig: {
    generalLinks: {
      addonListingWithHosting: {
        href: '/apps/{pluginId}/{appName}{?hosting,tab}',
        templated: true,
      },
    },
    addonDiscovery: {
      metricsKeys: {
        discover: 'http.home.get',
        search: 'http.search.get',
        application: 'http.addons_app_application.get',
        applicationSilter: 'http.addons_app_application_silter.get',
        silter: 'http.addons_silter.get',
      },
      links: {
        application: {
          href: '/addons/app/{application}',
          templated: true,
        },
        applicationSilter: {
          href: '/addons/app/{application}/{silter}',
          templated: true,
        },
        home: {
          href: '/',
        },
        silter: {
          href: '/addons/{silter}',
          templated: true,
        },
        search: {
          href: '/search',
        },
      },
    },
    solutions: {
      solutions: [
        {
          key: 'project-management',
          name: 'Project management',
        },
        {
          key: 'themes-styles',
          name: 'Themes and styles',
        },
        {
          key: 'test-management',
          name: 'Test management',
        },
        {
          key: 'monitoring',
          name: 'Monitoring',
        },
        {
          key: 'it-service-management',
          name: 'IT service management',
        },
        {
          key: 'document-management',
          name: 'Document management',
        },
        {
          key: 'continuous-integration',
          name: 'Continuous integration',
        },
        {
          key: 'charts-diagrams',
          name: 'Charts and diagrams',
        },
        {
          key: 'design-tools',
          name: 'Design tools',
        },
        {
          key: 'time-tracking',
          name: 'Time tracking',
        },
      ],
      metricsKeys: {
        solution: 'http.categories_category.get',
      },
      links: {
        solution: {
          href: '/categories/{category}',
          templated: true,
        },
      },
    },
    collections: {
      metricsKeys: {
        collection: 'http.categories_collection.get',
      },
      links: {
        collection: {
          href: '/categories/{collection}',
          templated: true,
        },
        collections: [
          {
            key: 'devops',
            name: 'DevOps',
            link: {
              href: '/categories/devops',
            },
          },
        ],
      },
    },
    vendorDetails: {
      metricsKeys: {
        vendorDetails: 'http.vendors_vendorId_vendorName.get',
      },
      links: {
        vendorDetailsPage: {
          href: '/vendors/{vendorId}/{vendorName}',
          templated: true,
        },
      },
    },
  },
};
